// NOTE we have to split the booking fields to avoid recursive import issues
// between bookings and contracts

import { TemplateVariable } from '@tools/interfaces/template';

export const getBookingFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.bookings.code.label',
      contentValue: '{{ booking.code }}',
      description: 'templates.bookings.code.description',
    },
    {
      label: 'templates.bookings.name.label',
      contentValue: '{{ booking.name }}',
      description: 'templates.bookings.name.description',
    },
    {
      label: 'templates.bookings.status.label',
      contentValue: '{{ booking.status }}',
      description: 'templates.bookings.status.description',
    },
    {
      label: 'templates.bookings.booking_type.label',
      contentValue: '{{ booking.booking_type }}',
      description: 'templates.bookings.booking_type.description',
    },
    {
      label: 'templates.bookings.repetitive.label',
      contentValue: '{{ booking.repetitive }}',
      description: 'templates.bookings.repetitive.description',
    },
    {
      label: 'templates.bookings.comment.label',
      contentValue: '{{ booking.comment }}',
      description: 'templates.bookings.comment.description',
    },
    {
      label: 'templates.bookings.start_date.label',
      contentValue: '{{ booking.start_date | date("d/m/Y") }}',
      description: 'templates.bookings.start_date.description',
    },
    {
      label: 'templates.bookings.end_date.label',
      contentValue: '{{ booking.end_date | date("d/m/Y") }}',
      description: 'templates.bookings.end_date.description',
    },
    {
      label: 'templates.bookings.start_time.label',
      contentValue: '{{ booking.start_time | date("H:i") }}',
      description: 'templates.bookings.start_time.description',
    },
    {
      label: 'templates.bookings.end_time.label',
      contentValue: '{{ booking.end_time | date("H:i") }}',
      description: 'templates.bookings.end_time.description',
    },
    {
      label: 'templates.bookings.booking_price.label',
      contentValue: '{{ booking.booking_price }}',
      description: 'templates.bookings.booking_price.description',
    },
    {
      label: 'templates.bookings.discipline_name.label',
      contentValue: '{{ booking.discipline.name }}',
      description: 'templates.bookings.discipline_name.description',
    },
    {
      label: 'templates.bookings.discipline_code.label',
      contentValue: '{{ booking.discipline.code }}',
      description: 'templates.bookings.discipline_code.description',
    },
  ];
};
